export default function GetStarted() {
    return (
        <section
            className="py-20 px-6 text-center bg-gradient-to-b from-[#4916CF] to-[#250B69]"
        >
            <div className="max-w-5xl mx-auto">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                    Get Started with
                    <br />
                    AstraMiner
                </h2>

                <p className="text-white text-base md:text-lg max-w-4xl mx-auto leading-relaxed">
                    ASTRAMINER is your go-to for learning blockchain transactions. Dive
                    into interactive tools, practice transactions, and resources. Explore
                    blockchain with ease!
                </p>
            </div>
        </section>
    );
}
